<template>
  <div id="MainProductBanner">
    <div class="uk-section uk-section-muted" id="mainBanner">
      <div class="uk-container">
        <div
          class="uk-flex uk-flex-middle"
          uk-height-match
          uk-grid
          style="margin: 5% 0"
          uk-scrollspy="cls: uk-animation-fade; target: > div; delay: 500; repeat: false;"
        >
          <div
            class="uk-width-1-2@s uk-padding-remove-left"
            uk-scrollspy-class="uk-animation-slide-left"
          >
            <div>
              <h1>{{ productName }}</h1>
            </div>
            <div>
              <h3>{{ header }}</h3>
            </div>
            <div>
              <ul>
                <li v-for="p in productFeatures" :key="p">{{ p }}</li>
              </ul>
            </div>
            <div style="font-size: 20px;font-weight:bold;">{{ price != '' ? priceRupiah(price) : '' }}</div>
            <div class="uk-margin-medium-top">
              <button
                class="uk-button uk-button-primary"
                style="border-radius: 10px"
                @click="buyNow()"
              >
                Buy Now
              </button>
              <a href="https://www.tokopedia.com/roomiid" target="_blank" rel="noopener noreferrer" class="uk-button uk-button-default uk-margin-left" style="border-radius: 10px">Tokopedia</a>
            </div>
          </div>
          <div
            class="uk-width-1-2@s uk-position-relative uk-padding-remove-left"
            uk-scrollspy-class="uk-animation-slide-right"
          >
            <figure
              :style="{
                marginTop: `${marginTop}`,
                marginBottom: `${marginBottom}`,
              }"
            >
              <img
                class=""
                :src="image"
                :alt="product"
                :style="{ transform: `${transform}` }"
              />
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UIkit from "uikit";
import $axios from "@/api.js";
export default {
  props: [
    "productName",
    "tagline",
    "features",
    "directLink",
    "img",
    "posTop",
    "posBottom",
    "imageScale",
    "price",
    "id",
  ],
  data() {
    return {
      product: this.productName,
      header: this.tagline,
      productFeatures: this.features,
      videoUrl: this.directLink,
      image: this.img,
      marginTop: this.posTop,
      marginBottom: this.posBottom,
      transform: this.imageScale,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
  },
  methods: {
    ...mapActions("cart", ["getCarts"]),
    buyNow() {
      if (this.IS_AUTH) {
        $axios
          .post("cart/add_cart", {
            id_cust: this.GET_USER.id,
            prod_id: this.id,
            qty: 1,
          })
          .then((result) => {
            if (result.status == 200) {
              const data = result.data;
              if (data.status == "success") {
                this.getCarts(this.GET_USER.id);
                this.$router.push("/cart");
              } else {
                UIkit.notification({message: data.message, status: 'danger'})
              }
            } else {
              UIkit.notification({message: 'Something went wrong!', status: 'danger'})
            }
          })
          .catch((err) => {
            console.log(err.message);
            UIkit.notification({message: 'Something went wrong!', status: 'danger'})
          });
      } else {
        const modalLogin = document.querySelector("#modal-login");
        UIkit.modal(modalLogin).show();
      }
    },
    priceRupiah: function (number) {
      let reverse = number.toString().split("").reverse().join("");
      let ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");
      return "Rp " + ribuan;
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 2.5vw;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 5px;
  margin-bottom: 0;
  transform: scaleX(1.15);
  transform-origin: left;
  max-width: 75% !important;
}

h3 {
  margin: 1vw 0 0 0;
  text-transform: uppercase;
  font-size: 1.5vw;
  letter-spacing: 3px;
  font-weight: lighter;
  color: rgb(0, 0, 0);
}

ul {
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  line-height: 1;
  width: 50%;
}

li {
  padding: 2.5px 0;
  text-transform: capitalize;
  color: rgb(164, 173, 184);
  word-spacing: 2px;
  font-weight: 300;
  letter-spacing: 1.5px;
}

li::after {
  content: "|";
  margin-left: 5px;
  margin-right: 5px;
}

li:last-child::after {
  content: "";
}

figure {
  display: block;
}

@media screen and (max-width: 639px) {
  figure {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  figure img {
    max-width: 100%;
    transform: none !important;
  }

  h1 {
    font-size: 24px;
  }

  h3 {
    font-size: 14px;
  }

  ul {
    width: 100%;
  }
}
</style>